import { z } from "zod";

import axiosWithAuth from "@/lib/axios";
import { instructorSchema } from "@/types/database/instructor";

export const INSTRUCTORS_URL = '/ezcon/api/instructors';

const instructorListSchema = z.array(instructorSchema);

export const getInstructors = async (url: string) => {
  const { data } = await axiosWithAuth.get(url);
  const validatedData = instructorListSchema.parse(data);
  return validatedData;
}

export const postInstructor = async (instructor: FormData) => {
  const { data } = await axiosWithAuth.post(INSTRUCTORS_URL, instructor);
  return data;
}

export const patchInstructor = async (id: string, instructor: FormData) => {
  const { data } = await axiosWithAuth.patch(`${INSTRUCTORS_URL}/${id}`, instructor);
  return data;
}

export const deleteInstructor = async (instructorId: string) => {
  const { data } = await axiosWithAuth.delete(`${INSTRUCTORS_URL}/${instructorId}`);
  return data;
}